import React, { FC } from "react";

type AdditionalCheckButtonProps = {
  label: string;
  buttonLabel: string;
  onClickFunction: () => void;
};

export const AdditionalCheckButton: FC<AdditionalCheckButtonProps> = ({
  label,
  buttonLabel,
  onClickFunction,
}) => {
  return (
    <>
      <span>{label} </span>
      {buttonLabel && (
        <a
          className="fw-bold underline"
          role="button"
          onClick={(e) => {
            e.preventDefault();
            onClickFunction();
          }}
        >
          {buttonLabel}
        </a>
      )}
    </>
  );
};
